import React, { memo } from 'react';
import { FontAwesomeIcon as SelectedIcon } from '@fortawesome/react-fontawesome';
import * as duotone from '@fortawesome/pro-duotone-svg-icons';
import { camelCase } from 'lodash';

import PropTypes from 'prop-types';

export const Icon = memo(
  ({ name, type = 'duotone', size = 'xl', ...props }) => {
    const iconType = type === 'duotone' && duotone[camelCase(`fa-${name}`)];
    return <SelectedIcon icon={iconType} size={size} {...props} />;
  },
);

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  size: PropTypes.oneOf([
    '2xs',
    'xs',
    'sm',
    'lg',
    'xl',
    '2xl',
    '1x',
    '2x',
    '3x',
    '4x',
    '5x',
    '6x',
    '7x',
    '8x',
    '9x',
    '10x',
  ]),
};
